import React from "react";
import PropTypes from "prop-types";

// Lodash
import _map from "lodash/map";
import _noop from "lodash/noop";

// Components
import { Statistic, Row } from "antd";
import { PageHeader as AntdPageHeader } from "@ant-design/pro-layout";
import Button, { BUTTON_TYPES } from "../../atoms/button";

// Constants
import { EMPTY_ARRAY } from "../../../constants";

// Styles
import styles from "./pageHeader.module.scss";

function renderStatisticDetails({
  title,
  value,
  styles = { marginLeft: 16, color: "#cf9c46" },
}) {
  return (
    <Statistic
      title={title}
      value={value}
      style={styles}
      key={title}
      valueStyle={{ color: "#cf9c46" }}
    />
  );
}
function renderAction({ title, handler = _noop, disabled, loading }) {
  return (
    <Button
      type={BUTTON_TYPES.PRIMARY}
      onClick={handler}
      key={title}
      disabled={disabled}
      loading={loading}
    >
      <span style={{ color: "white" }}> {title}</span>
    </Button>
  );
}

function PageHeader({ title, subTitle, statistics, actions }) {
  return (
    <AntdPageHeader
      onBack={() => window.history.back()}
      title={title}

      subTitle={subTitle}
      extra={_map(actions, renderAction)}
      className={styles.pageTitle}
    >
      <Row>{_map(statistics, renderStatisticDetails)}</Row>
    </AntdPageHeader>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  statistics: PropTypes.array,
};

PageHeader.defaultProps = {
  subTitle: "",
  statistics: EMPTY_ARRAY,
};

export default PageHeader;
